import React, { useState } from 'react';
import ImageModal from '../modals/ImageModal';
const ArtFormSection = ({ id, title, image, description, reverse = false }) => {
    const [showModal, setShowModal] = useState(false);
    return (
        <section id={id} className="py-20 bg-black">
            <div className="container mx-auto px-4">
                {/* Mobile Layout */}
                <div className="md:hidden flex flex-col items-center gap-8">
                    <h2 className="text-4xl font-bold mb-6 section-heading w-full">
                        {title}
                    </h2>
                    <img 
                        src={image} 
                        alt={title} 
                        className="w-full h-auto rounded-lg shadow-xl cursor-pointer"
                        loading="lazy"
                        onClick={() => setShowModal(true)}
                    />
                    <div className="text-lg text-gray-300 w-full">
                        {description}
                    </div>
                </div>

                {/* Desktop Layout */}
                <div className={`hidden md:flex ${reverse ? 'flex-row-reverse' : 'flex-row'} items-center gap-12`}>
                    <div className="w-1/2">
                        <img 
                            src={image} 
                            alt={title} 
                            className="w-full h-auto rounded-lg shadow-xl cursor-pointer"
                            loading="lazy"
                            onClick={() => setShowModal(true)}
                        />
                    </div>
                    <div className="w-1/2">
                        <h2 className="text-5xl font-bold mb-6 section-heading">
                            {title}
                        </h2>
                        <div className="text-lg text-gray-300">
                            {description}
                        </div>
                    </div>
                </div>
            </div>

            {showModal && (
                <ImageModal
                    image={image}
                    title={title}
                    description={description}
                    onClose={() => setShowModal(false)}
                    onNext={() => {}}
                    onPrev={() => {}}
                    hasNext={false}
                    hasPrev={false}
                />
            )}
        </section>
    );
};

export default ArtFormSection;
